import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../components/InfoPage';
import './Organisations.css';

const POINTS = ['one', 'two', 'three'];

function Organisations() {
  const { t } = useTranslation();

  return (
    <InfoPage ns="organisations">
      <ul className="org-points">
        {POINTS.map((key) => (
          <li key={key} className="org-point">
            <h2>{t(`organisations.points.${key}.title`)}</h2>
            <p>{t(`organisations.points.${key}.text`)}</p>
          </li>
        ))}
      </ul>
      <Link to="/contact" className="button button-primary org-cta">
        {t('organisations.cta')}
      </Link>
    </InfoPage>
  );
}

export default Organisations;
